import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import apiClient from "../api.js";
import {
  signOutUserFailure,
  signOutUserStart,
  signOutUserSuccess,
} from "../redux/user/userSlice";
// import { toast, ToastContainer } from "react-toastify";

const Profile = () => {
  const navigate = useNavigate();
  const [showProperties, setShowProperties] = useState(false);
  const [showPlots, setShowPlots] = useState(false);
  const [userProperties, setUserProperties] = useState([]);
  const [userPlots, setUserPlots] = useState([]);
  // const notify = () => toast("User not deleted please try again!");
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);

  // const handleDeleteUser = async () => {
  //   try {
  //     dispatch(deleteUserStart());

  //     const user_Id = document.getElementById("userId").value;
  //     const res = await apiClient.delete(
  //       `user/delete/${currentUser._id}`,
  //       user_Id
  //     );

  //     const data = await res.json();
  //     console.log(data);
  //     console.log(res.json());
  //     if (data.success === false) {
  //       // notify();
  //       dispatch(deleteUserFailure(data.message));
  //       return;
  //     } else {
  //       dispatch(deleteUserSuccess(data));
  //       return;
  //     }
  //   } catch (error) {
  //     localStorage.clear();
  //     dispatch(deleteUserSuccess());
  //     navigate("/");

  //   }
  // };

  // handle sign out
  const handleSignOut = async () => {
    try {
      dispatch(signOutUserStart());
      const singOutRes = await apiClient.get("auth/signout");

      localStorage.clear();
      dispatch(signOutUserSuccess(singOutRes));
      navigate("/sign-in");
    } catch (error) {
      dispatch(signOutUserFailure(error));
    }
  };

  // get All properties

  const getAllProperties = async () => {
    try {
      const user_Id = document.getElementById("userId").value;

      if (user_Id === "672873216d6bedd7141bf7a2") {
        const allProperties = await apiClient.get(`user/properties/${user_Id}`);
        setUserProperties(allProperties.data);
      } else {
        const allProperties = await apiClient.get(`user/properties/${user_Id}`);
        setUserProperties(allProperties.data);
      }
    } catch (error) {
      setShowProperties(true);
    }
  };

  // Get All Plots

  const getAllPlots = async () => {
    try {
      const user_Id = document.getElementById("userId").value;

      if (user_Id === "672873216d6bedd7141bf7a2") {
        const allPlots = await apiClient.get(`user/plots/${user_Id}`);
        setUserPlots(allPlots.data);
      } else {
        const allPlots = await apiClient.get(`user/plots/${user_Id}`);
        setUserPlots(allPlots.data);
      }
    } catch (error) {
      setShowPlots(true);
    }
  };

  // delete Property
  // const handleDeleteProperty = async (listingId) => {
  //   try {
  //     const deleteProperty = await apiClient.delete(
  //       `listing/delete/${listingId}`
  //     );

  //     const data = deleteProperty.data;
  //     if (data.success === false) {
  //       console.log(data.message);
  //       return;
  //     }

  //     setUserProperties((prev) =>
  //       prev.filter((listing) => listing._id !== listingId)
  //     );
  //     console.log(deleteProperty);
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  return (
    <>
      <section className="sign-up-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="sign-up-div">
                <h1 className="sign-up-txt mt-3">Profile</h1>
                <p className="user-icon-p ">
                  <FaUser className="user-icon" />
                </p>
                <form>
                  <input
                    type="text"
                    className="usernameinput"
                    placeholder="Username"
                    value={currentUser.username}
                    id="username"
                  />
                  <input
                    type="email"
                    className="usernameinput mt-3"
                    placeholder="Email"
                    value={currentUser.email}
                    id="email"
                  />
                  <input
                    type="password"
                    className="usernameinput mt-3"
                    placeholder="Password"
                    value={currentUser.password}
                    id="password"
                  />
                  <input
                    type="hidden"
                    className="usernameinput mt-3"
                    placeholder="Id"
                    id="userId"
                    value={currentUser._id}
                  />
                  {/* <button className="sing-up-btn mt-3">UPDATE</button> */}
                  <button className="create-listing-btn mt-3">
                    <Link to={"/create-listing"}>CREATE LISTING</Link>
                  </button>
                  <button className="create-listing-btn mt-3">
                    <Link to={"/create-plot-listing"}>PLOT LISTING</Link>
                  </button>
                </form>
                <p
                  onClick={getAllProperties}
                  className="show-listing pb-3 mt-3"
                >
                  <Link>Show Properties</Link>
                </p>
                <p onClick={getAllPlots} className="show-listing pb-3 mt-3">
                  <Link>Show Plots</Link>
                </p>
                <p className="show-listing pb-3 mt-3">
                  <Link to="/properties-order">Display Properties</Link>
                </p>
                <p className="text-danger">
                  {showProperties ? "Error showing properties" : ""}
                </p>
                <p className="text-danger">
                  {showPlots ? "Error showing plots" : ""}
                </p>
                <p onClick={handleSignOut} className="have-account-txt  mt-3">
                  <Link>Sign Out</Link>
                </p>

                {/* <p onClick={handleDeleteUser} className="have-account-txt ">
                  <Link>Delete Account</Link>
                </p> */}

                {userProperties &&
                  userProperties.length > 0 &&
                  userProperties.map((listing) => (
                    <div
                      className="profile-page-properties-div"
                      key={listing._id}
                    >
                      <div></div>
                      <div>
                        <Link
                          className="property-name-link-txt"
                          to={`/property-detail/${listing.slug}`}
                        >
                          <p className="profile-property-name">
                            {listing.name.slice(0, 20)}...
                            {/* {listing.name} */}
                          </p>
                        </Link>
                      </div>
                      <div className="property-btn-div">
                        {/* <button
                          onClick={() => handleDeleteProperty(listing._id)}
                          className="btn-delete"
                        >
                          Delete
                        </button> */}
                        <Link to={`/update-listing/${listing._id}`}>
                          <button className="btn-update">Update</button>
                        </Link>
                      </div>
                    </div>
                  ))}
                {userPlots &&
                  userPlots.length > 0 &&
                  userPlots.map((plot) => (
                    <div className="profile-page-properties-div" key={plot._id}>
                      <div></div>
                      <div>
                        <Link
                          className="property-name-link-txt"
                          to={`/property-detail/${plot.slug}`}
                        >
                          <p className="profile-property-name">
                            {plot.name.slice(0, 20)}...
                            {/* {listing.name} */}
                          </p>
                        </Link>
                      </div>
                      <div className="property-btn-div">
                        {/* <button
                          onClick={() => handleDeleteProperty(listing._id)}
                          className="btn-delete"
                        >
                          Delete
                        </button> */}
                        <Link to={`/update-plot-listing/${plot._id}`}>
                          <button className="btn-update">Update</button>
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        {/* <ToastContainer /> */}
      </section>
    </>
  );
};

export default Profile;
